import React from 'react';

export function SettingsPanel({ title, description, badge, children }) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200/80 shadow-sm overflow-hidden">
      <div className="px-6 sm:px-8 py-6 border-b border-gray-100 bg-gradient-to-r from-gray-50/80 via-white to-orange-50/30">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div>
            <h2 className="text-xl font-semibold text-gray-900 tracking-tight">{title}</h2>
            {description && (
              <p className="mt-1.5 text-sm text-gray-600 leading-relaxed max-w-2xl">{description}</p>
            )}
          </div>
          {badge && (
            <span className="inline-flex items-center rounded-full bg-orange-50 text-orange-700 border border-orange-100 px-3 py-1 text-xs font-semibold">
              {badge}
            </span>
          )}
        </div>
      </div>
      <div className="p-6 sm:p-8">{children}</div>
    </div>
  );
}

export function SettingsField({ label, hint, children, className = '' }) {
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-800 mb-1.5">{label}</label>
      {children}
      {hint && <p className="mt-2 text-xs text-gray-500 leading-relaxed">{hint}</p>}
    </div>
  );
}

export function SettingsSaveButton({ onClick, disabled, loading, children, variant = 'primary' }) {
  const styles = {
    primary: 'bg-gray-900 hover:bg-gray-800 text-white',
    accent: 'bg-orange-600 hover:bg-orange-700 text-white',
    outline: 'border border-orange-300 text-orange-700 hover:bg-orange-50'
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`inline-flex items-center justify-center px-4 py-2.5 rounded-xl text-sm font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${styles[variant]}`}
    >
      {loading ? 'Saving…' : children}
    </button>
  );
}
